var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKairo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45065 0.404956C8.69032 0.00193809 9.20655 -0.120958 9.60293 0.130492C9.99932 0.381942 10.1191 0.912098 9.87019 1.31493L7.10471 5.85395C7.77764 6.00344 8.40455 6.43495 8.79172 7.14167L9.81494 9.0547C10.2851 9.92497 9.64903 10.9903 8.68111 10.9917C7.69475 10.9929 7.06786 9.88583 7.5933 9.03075L7.72237 8.81985C8.01736 8.33506 7.86989 7.69728 7.39975 7.3949C6.9204 7.09262 6.30277 7.24004 6.00779 7.72464L4.76334 9.75841C4.29321 10.5295 3.47279 10.9989 2.57862 11C0.624344 11.0024 -0.62019 8.85739 0.320073 7.09922L3.7309 0.707052C4.07198 0.0624872 4.97535 0.0608846 5.32564 0.704317C5.48235 0.999531 5.47311 1.35973 5.29796 1.64561L1.83188 7.32304C1.5369 7.80755 1.68437 8.44475 2.1545 8.74704C2.63385 9.04942 3.25149 8.90191 3.55569 8.4173L4.40382 7.0182C4.44069 6.96161 4.47756 6.90691 4.51443 6.85428L8.45065 0.404956Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKairo);
export default __webpack_public_path__ + "static/media/kairo.e5e29e35be393e2ee4561f60930931b9.svg";
export { ForwardRef as ReactComponent };